import * as React from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideMenu from "../../components/sidemenu/SideMenu";
import TopBar from "../../components/TopBar";
import { SidebarDrawer } from "../../components/common";
import SubscriptionAlert from "../../components/settings/Subscription/SubscriptionAlert";
import { ICustomer } from "../../@types";
import { useTour } from "../../context/TourContext";
import useRetailBusinessStatus from "../../hooks/invoice/useRetailBusinessStatus";
import { useDashboardTourGuide } from "../../components/tourGide/useDashboardTourGuide";
import { useIsMobile } from "../../components/tourGide/useIsMobile";
import { useCompanyStore } from "../../state/useCompanyStore";
import SubscriptionPage from "../../pages/Subscription";
import { useSubscription } from "../../context/SubscriptionProvider";

interface DashboardLayoutProps {}

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
  const { pathname } = useLocation();
  const allowedPaths = [
    "/expenses",
    "/invoices",
    "/quotes",
    "/customers",
    "/services",
    "/inventories",
    "/user-management",
  ];
  const { registerSteps, startTour } = useTour();
  const { company: user } = useCompanyStore();
  const { hasSubscription } = useSubscription();
  const isMobile = useIsMobile();
  const {
    dashboardTourGuide,
    isCollapsed,
    setIsCollapsed,
    setShowMobileMenu,
    showMobileMenu,
  } = useDashboardTourGuide();
  registerSteps("home", [...dashboardTourGuide]);

  React.useEffect(() => {
    if (user?.firstLogin && !isMobile && !!user.businessType) {
      startTour("home");
    }
  }, [registerSteps, user.businessType]);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(true);
  const [showAlert, setShowAlert] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [isExpired, setIsExpired] = React.useState(false);
  const [selectedCustomer, setSelectedCustomer] =
    React.useState<ICustomer | null>(null);

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const isRetailBusiness = useRetailBusinessStatus();
  let expired = false;
  let limitReached = false;

  if (expired) {
    setShowAlert(true);
    setIsExpired(true);
  }
  if (limitReached) {
    setShowAlert(true);
    setIsExpired(false);
  }

  return (
    <div id="#step-1" className="max-w-screen min-h-screen ">
      <div className="flex max-w-screen h-screen ">
        <SideMenu setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />
        <div
          className={`w-${isSidebarCollapsed ? "full" : "full"} ${
            pathname === "/dashboard" ? "bg-[#F2F4F7]" : "bg-[#ffffff]"
          } w-full border  overflow-x-hidden`}
        >
          <TopBar
            setShowMobileMenu={setShowMobileMenu}
            showMobileMenu={showMobileMenu}
            customer={selectedCustomer}
          />
          <div className="relative h-full w-full">
            {allowedPaths.includes(pathname) && !hasSubscription() && (
              <div className="bg-[#FFFAEB] px-6 py-4">
                <p className="text-[#101828] md:text-base text-sm font-medium">
                  Enjoy unlimited access to our robust features.{" "}
                  <button
                    onClick={() => setShowModal(true)}
                    className="text-[#93370D] underline "
                  >
                    Upgrade your plan.
                  </button>
                </p>
              </div>
            )}
            <div className="pt-[16px] md:pt-6 px-4 md:px-6 ">
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      <SidebarDrawer title="" position="left" show={showAlert}>
        <SubscriptionAlert isExpired={isExpired} />
      </SidebarDrawer>
      {showModal && (
        <SubscriptionPage
          close={() => setShowModal(false)} // Close modal
        />
      )}
    </div>
  );
};

export default DashboardLayout;
